module.exports = __webpack_public_path__ + "static/media/testresult.bcaafd6b.png";